import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import GestureIcon from '@material-ui/icons/Gesture';

import TripDetailBadge from './TripDetailBadge.jsx';

const StyledTripOverviewPanel = styled(Link)`
  color: #4a4a4a;
  display: block;
  max-width: 600px;
  background-color: #ffffff;
  border-radius: 8px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.18);
  box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.18);
  margin-bottom: 35px;
  overflow: hidden;

  & img {
    height: auto;
    display: block;
    border-bottom: #dedede 1px solid;
  }
`;

const TripBadges = styled.div`
  background-color: #f1f3f4;
  display: flex;
  justify-content: space-around;
  padding-top:5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
`;

const distanceLabel = distanceMiles => `${distanceMiles.toFixed(1)} mi`;

const durationLabel = (durationSeconds) => {
  const hours = Math.floor(durationSeconds / 3600);
  const minutes = Math.floor((durationSeconds - (hours * 3600)) / 60);

  if (hours === 0 && minutes === 0) {
    return '0 mins';
  }

  let output = '';
  if (hours > 0) { output += `${hours} hr${hours > 1 ? 's' : ''}`; }
  if (hours > 0 && minutes > 0) { output += ', '; }
  if (minutes > 0) { output += `${minutes} min${minutes > 1 ? 's' : ''}`; }

  return output;
};

const dateLabel = dateStr => moment(dateStr).format('dddd, MMMM Do');

const durationStartEndLabel = (startedAt, endedAt) => {
  const startTime = moment(startedAt);
  const endTime = moment(endedAt);
  const startLabel = startTime.format('h:mm A');
  const endLabel = endTime.format('h:mm A');

  let output = `${startLabel} - ${endLabel}`;

  if (startTime.format('D') !== endTime.format('D')) {
    output += ' (+1 day)';
  }

  return output;
};

const infractionBadgeColor = (score) => {
  if ((!score && score !== 0) || score > 90) {
    return null;
  }

  if (score > 40) {
    // Orange
    return '#cc8400';
  }

  // Pale Red
  return '#FF7474';
};

function TripOverviewPanel(props) {
  const {
    startedAt,
    endedAt,
    duration,
    distanceMiles,
    numInfractionEvents,
    driverScore,
    mapUrl,
    device: { id: deviceId = null },
  } = props.trip;

  const deviceName = props.trip.device.name;

  const infractionsTitle = (numInfractionEvents || numInfractionEvents === 0) ? numInfractionEvents : 'N/A';

  const startAt = moment(startedAt).toISOString();
  const endAt = moment(endedAt).toISOString();
  const url = `/home?mode=history&startAt=${startAt}&endAt=${endAt}&deviceFilter=${deviceId}`;
  return (
    <StyledTripOverviewPanel to={url}>
      <img width="600px" height="300px" src={mapUrl} />
      <TripBadges>
        <TripDetailBadge
          title={distanceLabel(distanceMiles)}
          subtitle="Distance"
          icon={<GestureIcon fontSize="inherit"/>}
        />
        <TripDetailBadge
          title={durationLabel(duration)}
          subtitle="Time"
          icon={<AccessAlarmIcon fontSize="inherit"/>}
        />
        <TripDetailBadge
          title={infractionsTitle}
          subtitle="Infractions"
          icon={<WarningRoundedIcon fontSize="inherit"/>}
          color={infractionBadgeColor(driverScore)}
        />
      </TripBadges>
      <TripInfo
        title={dateLabel(startedAt)}
        subtitle={durationStartEndLabel(startedAt, endedAt)}
        deviceName={deviceName}
        />
    </StyledTripOverviewPanel>
  );
}

const StyledTripInfo = styled.div`
  display: flex;
  align-items: flex-end;
  padding-top:5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
`;

const TripInfoBody = styled.div`
  flex-grow: 1;
`;

const TripInfoBodyTitle = styled.div`
  font-size: 0.9em;
  padding-bottom: 5px;
  font-weight: 500;
`;

const TripInfoBodySubtitle = styled.div`
  font-size: 0.7em;
  color: #7A7A7A;
`;

const TripInfoDeviceBadge = styled.div`
  background-color: #4a4a4a;
  border-radius: 4px;
  color: #ffffff;
  padding-top: 2px;
  font-weight: 600;
  font-size: .9em;
  padding-bottom: 2px;
  padding-left: 4px;
  padding-right: 4px;
  font-size: 0.7em;
`;

function TripInfo(props) {
  return (
    <StyledTripInfo>
      <TripInfoBody>
        <TripInfoBodyTitle>{props.title}</TripInfoBodyTitle>
        <TripInfoBodySubtitle>{props.subtitle}</TripInfoBodySubtitle>
      </TripInfoBody>
      <TripInfoDeviceBadge>{props.deviceName}</TripInfoDeviceBadge>
    </StyledTripInfo>
  );
}

TripOverviewPanel.propTypes = {
  trip: PropTypes.object.isRequired,
};


export default TripOverviewPanel;
